import React from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import "./MobileAppDevelopment.css";

function MobileAppDevelopment() {
  const navigate = useNavigate();

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Do you provide mobile app development services in USA, Dubai and Saudi Arabia?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. SamSoftix provides international mobile app development services for businesses in the USA, UAE (Dubai), and Saudi Arabia."
        }
      },
      {
        "@type": "Question",
        "name": "How much does mobile app development cost?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "App development cost depends on features, complexity and platform. Contact us for a custom quote in USD or AED."
        }
      },
      {
        "@type": "Question",
        "name": "Do you build both iOS and Android apps?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. We develop native iOS apps, Android apps and cross-platform applications using Flutter and React Native."
        }
      }
    ]
  };

  return (
    <main className="appdev-page">
      <Helmet>
        <title>Mobile App Development Company | USA, Dubai & Saudi Arabia | SamSoftix</title>
        <meta
          name="description"
          content="Professional mobile app development company serving USA, Dubai and Saudi Arabia. We build scalable iOS, Android and cross-platform apps for startups and enterprises."
        />
        <meta
          name="keywords"
          content="Mobile app development USA, App developers Dubai, Mobile app development Saudi Arabia, iOS Android development company"
        />
        <link rel="canonical" href="https://www.samsoftix.com/Mobile_App_Service_SamSoftix" />
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      </Helmet>

      {/* Hero */}
      <section className="appdev-hero">
        <h1>International Mobile App Development Company</h1>
        <p>
          We design and develop high-performance mobile applications for 
          businesses in USA, Dubai (UAE), and Saudi Arabia. 
          Transform your idea into a scalable digital product.
        </p>
        <button onClick={() => navigate("/serviceBooking")} className="appdev-btn">
          Book Free App Strategy Call
        </button>
      </section>

      {/* Services */}
      <section className="appdev-section">
        <h2>Our Mobile App Development Services</h2>
        <ul>
          <li>✔ iOS App Development</li>
          <li>✔ Android App Development</li>
          <li>✔ Cross-Platform Apps (Flutter & React Native)</li>
          <li>✔ E-commerce & Marketplace Apps</li>
          <li>✔ Enterprise & Business Applications</li>
          <li>✔ App UI/UX Design</li>
        </ul>
      </section>

      {/* Business Impact */}
      <section className="appdev-section">
        <h2>How Mobile Apps Grow Your Business</h2>
        <p>
          A professionally developed mobile app increases customer engagement,
          improves brand loyalty, and generates new revenue streams.
          Whether you are targeting users in the USA, UAE or Saudi Arabia,
          our apps are built for performance, security and scalability.
        </p>
      </section>

      {/* Technologies */}
      <section className="appdev-section">
        <h2>Technologies We Use</h2>
        <p>
          Flutter, React Native, Swift, Kotlin, Firebase, Node.js,
          AWS cloud infrastructure and secure backend systems.
        </p>
      </section>

      {/* Pricing */}
      <section className="appdev-section">
        <h2>Mobile App Development Pricing</h2>

        <div className="pricing-box">
          <h3>Basic App (MVP)</h3>
          <p>Starting from $4,000 USD / 15,000 AED</p>
        </div>

        <div className="pricing-box">
          <h3>Business App</h3>
          <p>Starting from $8,000 USD / 30,000 AED</p>
        </div>

        <div className="pricing-box">
          <h3>Enterprise Solution</h3>
          <p>Custom Pricing</p>
        </div>
      </section>

      {/* Testimonials */}
      <section className="appdev-section">
        <h2>What Our International Clients Say</h2>

        <div className="testimonial-box">
          <p>
            "SamSoftix developed our delivery app for Dubai market with excellent UI and performance."
          </p>
          <strong> Dubai Startup Founder</strong>
        </div>

        <div className="testimonial-box">
          <p>
            "Professional mobile app development team with strong communication and technical expertise."
          </p>
          <strong> USA Client</strong>
        </div>
      </section>

      {/* CTA */}
      <section className="appdev-cta">
        <h2>Ready to Launch Your Mobile App?</h2>
        <p>
          Let SamSoftix build a scalable, secure and high-performing mobile app for your business.
        </p>
        <button onClick={() => navigate("/serviceBooking")} className="appdev-btn">
          Start Your App Project
        </button>
      </section>
    </main>
  );
}

export default MobileAppDevelopment;